import { Button, Typography } from 'components';
import styles from './MagicLink.module.scss';
import { useTranslation } from 'react-i18next';

type Props = {
  onClick: () => void;
};

function MagicLink({ onClick }: Props) {
  const { t } = useTranslation();
  return (
    <div data-test="magicLink">
      <Typography className={styles.info} dataTest="magicLink-info">
        {t('manual_upload_id:magic_link_info')}
      </Typography>
      <Button
        className={styles.button}
        type="submit"
        onClick={onClick}
        dataTest="magicLink-btn"
      >
        {t('manual_upload_id:send_sms')}
      </Button>
      <p
        className={styles.hint}
        dangerouslySetInnerHTML={{
          __html: t('manual_upload_id:magic_link_hint'),
        }}
        data-test="magicLink-hint"
      />
    </div>
  );
}

export default MagicLink;
